import { SecurityReference } from './security-reference-search-api-client.service';

export function renderSelectedSecurityText({ code, exchangeCode, id, name }: SecurityReference) {
  return `${code}.${exchangeCode} - ${name}`;
}
